'use client';
import { Container } from '@/components/Container';
import Section from '@/components/Section/Section';
import { PaymentProcessingBaner } from '@/features/PaymentProcessingBaner/PaymentProcessingBaner';
import { PaymentProcessingIntro } from '@/features/PaymentProcessingIntro/PaymentProcessingIntro';
import { PaymentProcessinngCards } from '@/features/PaymentProcessinngCards/PaymentProcessinngCards';
import { PaymentsMethodFrame } from '@/features/PaymentsMethodFrame/PaymentsMethodFrame';
import { WhatIs } from '@/features/WhatIs/WhatIs';
import {
  cards,
  whatIs0,
  whatIs1,
  whatIs2,
  whatIs3,
  whatIs4,
} from '@/lib/features/payment_processing';

const PaymentProcessingPage = () => {
  return (
    <>
      <PaymentProcessingIntro />
      <PaymentsMethodFrame />
      <Container>
        <Section>
          <WhatIs isVideo={false} {...whatIs0} />
        </Section>
      </Container>
      <PaymentProcessinngCards cards={cards} />
      <Container>
        <Section>
          <WhatIs revert={true} isVideo={false} {...whatIs1} />
        </Section>
      </Container>

      <Container>
        <Section>
          <WhatIs isVideo={false} {...whatIs2} />
        </Section>
      </Container>

      <PaymentProcessingBaner />

      <Container>
        <Section>
          <WhatIs revert={true} isVideo={false} {...whatIs3} />
        </Section>
      </Container>
      <Container>
        <Section>
          <WhatIs isVideo={false} {...whatIs4} />
        </Section>
      </Container>
    </>
  );
};

export default PaymentProcessingPage;
